import { createActionTypes } from "@helpers/redux-helpers";

export const getMyFollowersActionTypes = createActionTypes("followers/my");

export const getMyFollowersPortionActionTypes = createActionTypes(
  "followers/my/portion",
);

export const getMyFollowingsActionTypes = createActionTypes("followings/my");

export const getMyFollowingsPortionActionTypes = createActionTypes(
  "followings/my/portion",
);

export const getFollowersByIdActionTypes = createActionTypes("followers/byId");

export const getFollowersByIdPortionActionTypes = createActionTypes(
  "followers/byId/portion",
);

export const getFollowingsByIdActionTypes =
  createActionTypes("followings/byId");

export const getFollowingsByIdPortionActionTypes = createActionTypes(
  "followings/byId/portion",
);

export const favoriteFollowingActionTypes = createActionTypes(
  "followings/favorite",
);

export const unfavoriteFollowingActionTypes = createActionTypes(
  "followings/unfavorite",
);
